function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M13.234 19.318c1.383 3.217 3.718 6.398 6.985 7.77.373.155.797.272 1.232.369.87-1.298 1.868-2.35 3.038-3.213a15.221 15.221 0 0 1 3.142-1.771 8.967 8.967 0 0 0-.979-.595c-1.36-.71-2.832-1.336-4.265-2.008 1.348.365 2.894.5 4.184.971a9.7 9.7 0 0 1 2.237 1.189c2.063-.703 4.22-1.041 6.371-1.298-1.744-2.898-5.465-5.225-8.27-6.277-2.93-1.1-6.247-1.236-9.506-1.574-1.998-.206-4.169-.951-5.758-1.822-.36-.197-.745.132-.621.533.78 2.497 1.177 5.325 2.21 7.726",
  fill: "#49658A"
}), React.createElement("path", {
  d: "M47.673 18.938c-3.675 1.996-7.89 2.241-12.02 2.715-2.016.233-4.013.52-5.912 1.095-.412.124-.824.264-1.228.42-1.2.459-2.358 1.06-3.45 1.865a11.686 11.686 0 0 0-2.571 2.63c-1.127 1.57-1.912 3.375-2.556 5.252a29.959 29.959 0 0 0-1.613 10.628c.043 1.46.067 2.98.428 4.406.081.315.16.714.404.948.318.306.89-.008.761-.455-.924-3.15-.35-6.833.929-9.844 1.468-3.46 4.304-5.52 7.769-6.775.92-.334 1.86-.625 2.817-.902.02-.006.038-.006.058-.006.19 0 .271.279.074.368-1.127.509-2.246 1.022-3.31 1.578-5.214 2.718-7.49 9.05-5.536 9.05.16 0 .345-.042.56-.131 3.014-1.247 6.596-1.259 9.909-1.873 1.166-.213 2.3-.505 3.365-.948 4.226-1.763 7.249-5.213 9.047-9.362 1.34-3.096 1.861-6.752 2.875-9.968.132-.412-.16-.766-.517-.766a.531.531 0 0 0-.283.075",
  fill: "#49658A"
}), React.createElement("path", {
  d: "M27.5.635c-7.176 0-13.923 2.794-18.997 7.868S.635 20.324.635 27.5s2.794 13.922 7.868 18.997c5.074 5.074 11.821 7.868 18.997 7.868s13.923-2.794 18.997-7.868c5.074-5.075 7.868-11.821 7.868-18.997s-2.794-13.923-7.868-18.997S34.676.635 27.5.635M27.5 55c-7.345 0-14.251-2.86-19.445-8.055C2.86 41.751 0 34.845 0 27.5c0-7.346 2.86-14.251 8.055-19.445C13.249 2.86 20.155 0 27.5 0c7.345 0 14.251 2.86 19.445 8.055C52.14 13.249 55 20.155 55 27.5c0 7.346-2.86 14.251-8.055 19.445C41.751 52.14 34.845 55 27.5 55",
  fill: "#D1D1D1"
}));

const SvgIconResults1 = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 55,
  height: 55,
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIconResults1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-results-1.80f0fae1.svg";
export { ForwardRef as ReactComponent };